import { styled } from "@mui/material/styles";
import {
  Box,
  TableCell,
  Chip,
  IconButton,
  DialogTitle,
  Table,
  DialogContent,
  Typography,
} from "@mui/material";
import {
  VisibilityOutlined as VisibilityIcon,
  EditOutlined as EditIcon,
  DeleteOutlined as DeleteIcon,
  LaunchOutlined as LaunchIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  InfoOutlined,
} from "@mui/icons-material";

export const Container = styled(Box)({
  background: "#ffffff",
  borderRadius: "4px",
  padding: 0,
  marginTop: "15px",
  overflow: "hidden",
  boxShadow: "0px 0px 0px 1px rgba(224, 224, 224, 1)",
});

export const LoadingContainer = styled(Box)({
  background: "#ffffff",
  borderRadius: "4px",
  padding: "16px",
  marginTop: "15px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "200px",
});

export const ErrorContainer = styled(Box)({
  marginTop: "15px",
});

export const StyledTableCell = styled(TableCell)({
  padding: "16px",
  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
});

export const StyledTableCellID = styled(StyledTableCell)({
  width: "40px",
});

export const StyledTableCellProvider = styled(StyledTableCell)({
  width: "160px",
});

export const StyledTableCellStatus = styled(StyledTableCell)({
  width: "96px",
});

export const StyledTableCellMethod = styled(StyledTableCell)({
  width: "176px",
});

export const StyledTableCellChannels = styled(StyledTableCell)({
  width: "144px",
});

export const StyledTableCellFlags = styled(StyledTableCell)({
  width: "90px",
});

export const StyledTableCellLastUpdate = styled(StyledTableCell)({
  width: "160px",
});

export const StyledTableCellActions = styled(StyledTableCell)({
  width: "178px",
});

export const StyledChip = styled(Chip)({
  backgroundColor: "transparent",
  border: "none",
  fontSize: "14px",
  height: "24px",
});

export const ActionsBox = styled(Box)({
  display: "flex",
  gap: "8px",
});

export const ActionIconButton = styled(IconButton)({
  padding: 0,
  "&:hover": {
    backgroundColor: "transparent",
  },
});

export const FooterContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  padding: "16px",
  width: "100%",
  justifyContent: "flex-end",
});

export const PaginationBox = styled(Box)({
  display: "flex",
  gap: "8px",
});

export const ModalContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

export const ImportantNotice = styled(Box)({
  display: "flex",
  gap: "12px",
  alignItems: "flex-start",
  padding: "16px",
  borderRadius: "4px",
});

export const EditModalContainer = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  maxWidth: "1200px",
  maxHeight: "90vh",
  backgroundColor: "#ffffff",
  borderRadius: "4px",
  boxShadow:
    "0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
  outline: "none",
  overflow: "auto",
});

export const DialogTitleStyled = styled(DialogTitle)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  padding: "24px 24px 0 24px",
  background: "#FFFFFF",
  borderBottom: "none",
});

export const DialogTitleContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  flex: 1,
});

export const CloseButton = styled(IconButton)({
  color: "rgba(0, 0, 0, 0.54)",
  marginTop: "-4px",
});

export const StyledTable = styled(Table)({
  minWidth: 650,
});

export const StyledTableCellWithPadding = styled(TableCell)({
  padding: "16px",
});

export const VisibilityIconStyled = styled(VisibilityIcon)({
  fontSize: 24,
  color: "#202224",
});

export const EditIconStyled = styled(EditIcon)({
  fontSize: 24,
  color: "#202224",
});

export const DeleteIconStyled = styled(DeleteIcon)({
  fontSize: 24,
  color: "#D33100",
});

export const LaunchIconStyled = styled(LaunchIcon)({
  fontSize: 24,
  color: "#202224",
});

export const ChevronLeftIconStyled = styled(ChevronLeftIcon)({
  fontSize: 24,
  color: "rgba(0, 0, 0, 0.26)",
});

export const ChevronRightIconStyled = styled(ChevronRightIcon)({
  fontSize: 24,
  color: "rgba(0, 0, 0, 0.26)",
});

export const ModalTypography = styled(Typography)({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "32px",
  letterSpacing: "0.15px",
  color: "rgba(0, 0, 0, 0.87)",
});

export const ModalInfoIcon = styled(InfoOutlined)({
  fontSize: 20,
  color: "#1C1B1F",
  flexShrink: 0,
  marginTop: "2px",
});

export const ModalImportantText = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.17px",
  color: "rgba(0, 0, 0, 0.87)",
}) as typeof Typography;

export const ModalImportantTextBold = styled(Typography)({
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.17px",
  color: "rgba(0, 0, 0, 0.87)",
}) as typeof Typography;

export const DialogContentStyled = styled(DialogContent)({
  padding: 0,
});

export const DialogSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
